import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { LanguageBuilder } from '../../models/builder/language.builder';

@Injectable()
export class LanguageApiService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient
  ) {
    this.apiUrl = `${ environment.companyAdmin.apiUrl }languages`;
  }

  getLanguages() {
    return this.httpClient.get(`${ this.apiUrl }`)
      .pipe(map(LanguageBuilder.fromList));
  }
}
